import React from 'react';

export default function AddressAutocomplete({ value, onChange, onBlur, name, placeholder, className }) {
  return (
    <input
      type="text"
      name={name}
      value={value || ''}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={className}
    />
  );
}
